import React, { useMemo } from "react";
import { cn } from "~/lib/cn";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: unknown;
};

export const Input = React.memo(
  React.forwardRef<HTMLInputElement, InputProps>(
    ({ type, className, error, ...props }, ref) => {
      const inputClassName = useMemo(
        () =>
          cn(
            "input flex h-10",
            {
              "border-red-700 focus:border-red-700 focus:ring-red-200": error,
            },
            className,
          ),
        [error, className],
      );

      return (
        <input type={type} className={inputClassName} ref={ref} {...props} />
      );
    },
  ),
);

Input.displayName = "Input";
